var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E49E4E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19995 12C7.19995 9.34898 9.34898 7.19995 12 7.19995C14.6509 7.19995 16.8 9.34898 16.8 12C16.8 14.6509 14.6509 16.8 12 16.8C9.34898 16.8 7.19995 14.6509 7.19995 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxFill);
export default __webpack_public_path__ + "static/media/checkboxFill.592ec7c64bb62aea741863a56ea791d5.svg";
export { ForwardRef as ReactComponent };